module.exports = __webpack_public_path__ + "static/media/imgAIExpert.6593c47f.png";